"use client"

import { useState } from "react"
import { useNavigate } from "react-router"
import { Bell } from "lucide-react"
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar"
import { NotificationsModal } from "@/components/ui/notifications/notifications-modal"

export function ExplorerHeader() {
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)
  const navigate = useNavigate()

  // Mock function to handle marking notifications as read
  const handleMarkAsRead = (notificationId: string) => {
    console.log("Marking notification as read:", notificationId)
    // Implement your logic to mark notification as read
  }

  const handleMarkAllAsRead = () => {
    console.log("Marking all notifications as read")
    // Implement your logic to mark all notifications as read
  }

  const handleAvatarClick = () => {
    navigate("/profile")
  }

  return (
    <>
      <header className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-slate-900">Career Explorer</h1>
        <div className="flex items-center gap-4">
          {/* Notifications Bell Button */}
          <button
            onClick={() => setIsNotificationsOpen(true)}
            className="relative p-2 rounded-full hover:bg-slate-100 text-slate-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            aria-label="View notifications"
          >
            <Bell size={24} className="hover:text-blue-600 transition-colors" />
            <span className="absolute top-1 right-1 block h-2.5 w-2.5 rounded-full bg-red-500 border-2 border-white animate-pulse"></span>
          </button>

          {/* Avatar with Profile Routing */}
          <button
            onClick={handleAvatarClick}
            className="transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-full"
            aria-label="Go to profile"
          >
            <Avatar className="w-10 h-10 border-2 border-blue-500 cursor-pointer">
              <AvatarImage
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuCVALQAODBua8Bwyjnp8DY0rpuLKzwHTsoTFo6D9VODtc1sfXmvES8b3f1bIogQE5j7C0XeGQyU_Q7OV3zyYnt0b0Ln13YwoPkH_VkdNnVlaZTh-SUmS3c1E_sD5x4VpwNuaEuluJKIMcXESfm4aaV07bpeSrqUQWroyw3BH99G05OjYNaeQM95a4kMCXVAaiDecLyIe_vLUYLFf11ZpCgVfqLva3_NGTnEZBq55Bu3Qm8v7HAFdSq8cqGHOtAT_UEZAQEhjKsWm4s"
                alt="User Avatar"
              />
              <AvatarFallback className="bg-blue-100 text-blue-700 font-semibold">
                AB
              </AvatarFallback>
            </Avatar>
          </button>
        </div>
      </header>

      {/* Notifications Modal */}
      <NotificationsModal
        isOpen={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
        onMarkAsRead={handleMarkAsRead}
        onMarkAllAsRead={handleMarkAllAsRead}
        position="top-right"
      />
    </>
  )
}